import { render } from "./StockDiary.vue?vue&type=template&id=660c4f9e&scoped=true&ts=true"
import script from "./StockDiary.vue?vue&type=script&lang=ts"
export * from "./StockDiary.vue?vue&type=script&lang=ts"

import "./StockDiary.vue?vue&type=style&index=0&id=660c4f9e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660c4f9e"]])

export default __exports__